module.exports = __webpack_public_path__ + "img/monitoring_plan_white.f4ea9c8a.svg";